<template>
  <div>
    <Top />
    <div class="maindiv zindex-wrap">
      <div class="fmdiv pb40">
        <div class="fs34 tcenter twhite fbold nm">学员信息查询</div>
        <div class="tbdiv bgw mat br5" >
          <div class="tcenter tdiv">
            <span class="fs18 tc6 vcenter mr10">身份证号码</span>
            <div class="pinput br5 prelative ofhidden dinline-block bgw tleft dborder vcenter">
              <input class="input dinline-block fs16" v-model="cid" placeholder="">
              <a class="zbtn pabsolute trans3 fs20 twhite" href="javascript:void(0);" @click="find">查询</a>
            </div>
          </div>
          <div class="rndiv fs16 tc6 mat tcenter lh18" v-if="Object.getOwnPropertyNames(info).length > 1">
            <div>
              <span class="fbold fs18">{{info.nm}}</span>&nbsp;同学您好，您已报名
              <span class="ml5 mr5 tc-blue fs18">{{info.school | getSchool}}</span>
              <span class="mr5 tc-blue fbold">{{info.discipline | getDisc}}</span>专业
            </div>
            <div>
              目前，您的缴费已
              <span v-if="info.is_pay==1" class="fbold tc-orange fs18">成功付款</span>
              <span v-else class="fbold tc-red fs18">未支付</span>
            </div>
          </div>
          <div class="rndiv fs16 tc6 mat tcenter lh18" v-else>
            <div>
              无数据
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
  import Top from '../top.vue'
  import Bottom from '../bottom.vue'
  export default {
    name: "index",
    data () {
      return {
        info: {},
        cid: '',
      }
    },
    filters:{
      getSchool:function(index){
        var arr = ['','浙江科技学院','台州学院']
        return arr[index];
      },
      getDisc:function(index){
        var arr = ['','土木工程','工商管理']
        return arr[index];
      },
    },
    methods:{
      find(){
        if(this.cid == ''){
          return ;
        }
        var params = {};
        params['cid'] = this.cid
        this.$request.get('promotion-apply/query', params,response => {
          if(response.status == 200){
            if(response.data.code == 200){
              this.info = response.data.data
            }else{
              alert(response.data.message);
              this.info ={}
            }

          }
        },error => {
          console.log(error);
        })
      }
    },
    components:{
      Top,
      Bottom,
    },
    created() {

    },
    mounted() {
      $('.pinput input').focus(function(){
          $(this).parent().css({boxShadow: '0 0 8px #929eba', borderColor: '#929eba'});
      })

      $('.pinput input').blur(function(){
          $(this).parent().css({boxShadow: 'none', borderColor: '#ddd'});
      })
    }
  }
</script>

<style scoped>
 .fmdiv{background: #929eba;}
 .fmdiv .nm{padding: 70px 0 50px;}
 .tbdiv{padding-top: 75px;padding-bottom: 40px;width: 1075px;min-height: 530px;}
 .tdiv{margin-bottom: 140px;}
 .psearch{padding: 40px 40px 20px 140px;}
 .pinput{width: 550px;height: 42px;line-height: 42px;background: #fff;}
 .pinput .input{padding: 0 15px;width: 420px;height: 40px;line-height: 40px;}
 .pinput .input:focus{box-shadow: none;}
 .pinput .zbtn{width: 120px;line-height: 36px;bottom: 0;top: 0;right: 0;background: #929eba;}

 .tc-blue{color: #0283fc;}
 .tc-orange{color: #ff9900;}
 .tc-red{color: red;}
</style>



// WEBPACK FOOTER //
// src/components/zedu/index/search.vue